import React, { useContext, useRef } from 'react';
import Rail from '@cat/rail';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { PageDataContext } from '../../providers/page-data-provider';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import { useMobile } from '../../hooks/mobile.hook';
import useBRRedesignOpacity from '../../hooks/br-redesign-filter-opacity.hook';
import { getRailContainerStyles } from './styles';
import DesktopExperience from './experiences/desktop';
import MobileExperience from './experiences/mobile';

const RailContainer = (): JSX.Element => {
  const { onFacetChange, appliedFacetsCount } = useContext(PageDataContext);

  const isBRRedesignEnabled = useBRRedesign();
  const isMobileStyle = useMobile() || isBRRedesignEnabled;

  const { greaterOrEqualTo } = useContext(BreakpointContext);
  const isFixedHeader = greaterOrEqualTo(XLARGE);

  const isBRRedesignOpacityEnabled = useBRRedesignOpacity();
  const itemCountAndClearButtonRef = useRef<HTMLDivElement>();
  const stickyBuffer = isMobileStyle ? 0 : (itemCountAndClearButtonRef?.current?.offsetHeight ?? 0);

  return (
    <div
      className="rail-container"
      data-testid="rail-container"
      css={getRailContainerStyles(isMobileStyle, isBRRedesignEnabled, isFixedHeader)}
    >
      <Rail
        onFacetChange={onFacetChange}
        hasLeftFacetedGrid={!isMobileStyle}
        appliedFacetsCount={appliedFacetsCount}
        newDashboard={false}
        // @ts-ignore
        // TODO: Type should be fixed at @cat/rail package.
        stickyBuffer={stickyBuffer}
      >
        { isMobileStyle
          ? MobileExperience(appliedFacetsCount)
          : DesktopExperience(itemCountAndClearButtonRef, appliedFacetsCount)
        }
      </Rail>
    </div>
  );
};

export default RailContainer;
